module.exports = __webpack_public_path__ + "static/img/face7.7af91f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face7.jpg
// module id = AnJ5
// module chunks = 0